import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const dialogSlots = tv({
  slots: {
    root: ["Dialog__root"],
    backdrop: [
      "Dialog__backdrop",
      "fixed inset-0",
      "bg-black/30",
      "transition-all",
      "duration-150",
      "data-[ending-style]:opacity-0",
      "data-[starting-style]:opacity-0",
      "backdrop-blur",
    ],
    popup: [
      "Dialog__popup",
      "max-h-[calc(100%-3rem)]",
      "overflow-hidden",
      "fixed",
      "top-1/2",
      "left-1/2",
      "w-[calc(100%-3rem)]",
      "-translate-x-1/2",
      "-translate-y-1/2",
      "rounded-2xl",
      "bg-common-white",
      "p-6",
      "text-gray-900",
      "outline-none",
      "transition-all",
      "duration-150",
      "data-[ending-style]:scale-90",
      "data-[ending-style]:opacity-0",
      "data-[starting-style]:scale-90",
      "data-[starting-style]:opacity-0",
      "flex flex-col",
    ],
    title: ["Dialog__title", "-mt-1.5"],
    description: ["Dialog__description", "flex-1"],
    actions: [
      "Dialog__actions",
      "flex",
      "justify-end",
      "gap-4",
      "absolute",
      "top-2",
      "right-2",
    ],
    closeButton: [
      "flex size-10 items-center justify-center rounded-2xl  bg-transparent  text-base font-medium text-primary-main select-none hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-100",
    ],
  },
  variants: {
    maxWidth: {
      xs: {
        popup: ["max-w-screen-xs"],
      },
      sm: {
        popup: ["max-w-screen-sm"],
      },
      md: {
        popup: ["max-w-screen-md"],
      },
      lg: {
        popup: ["max-w-screen-lg"],
      },
      xl: {
        popup: ["max-w-screen-xl"],
      },
    },
    scrollabel: {
      true: {
        title: "p-6 pb-4",
        description: ["p-6"],
      },
    },
    disableGutters: {
      true: ["p-0"],
      false: ["p-6"],
    },
  },
  defaultVariants: {
    maxWidth: "sm",
    disableGutters: false,
  },
});

export const {
  root: dialogRootClasses,
  backdrop: dialogBackdropClasses,
  popup: dialogPopupClasses,
  title: dialogTitleClasses,
  description: dialogDescriptionClasses,
  actions: dialogActionsClasses,
  closeButton: dialogCloseButtonClasses,
} = dialogSlots();

export type DialogVariants = VariantProps<typeof dialogPopupClasses>;
